import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { keys, useSession } from '../services/queries';


export function usePremiumExpiry() {
  const until = useSession().data?.user?.premiumUntil;
  const client = useQueryClient();
  useEffect(() => {
    if (!until) return;
    const end = Date.parse(until);
    if (!Number.isFinite(end)) return;
    let timer: ReturnType<typeof setTimeout> | undefined;
    let expired = false;
    const check = () => {
      if (expired) return;
      if (timer) clearTimeout(timer);
      const remaining = end - Date.now();
      if (remaining > 0) {
        timer = setTimeout(check, Math.min(remaining, 2_147_483_647));
      } else {
        expired = true;
        for (const key of [keys.session, keys.me, keys.gacha, ['billing'], ['unlocks'], ['public_profile'], ['public_collection'], ['collection'], ['character'], ['market'], ['auctions'], ['auction'], ['trades'], ['trade'], ['trade_limits']]) {
          void client.invalidateQueries({ queryKey: key });
        }
      }
    };
    check();
    window.addEventListener('focus', check);
    return () => { if (timer) clearTimeout(timer); window.removeEventListener('focus', check); };
  }, [until, client]);
}
